import * as React from 'react';

import { FormattedMessage, useIntl } from 'react-intl';

import landing from 'src/assets/images/landing.webp';
import logo from 'src/assets/images/logo_white.png';
import { LANDING_SLIDES } from 'src/features/auth/utils';
import {
    Carousel,
    CarouselContent,
    CarouselDotButton,
    CarouselItem,
    CarouselItemSubtitle,
    CarouselItemTitle,
    CarouselNext,
    CarouselPrevious,
} from 'src/registry/ui/Carousel';

type LayoutProps = {
    children: React.ReactNode;
};

const AuthLayout = ({ children }: LayoutProps) => {
    const { formatMessage } = useIntl();

    return (
        <div className="bg-primary-700 grid min-h-screen w-full grid-rows-[auto_1fr] md:grid-cols-[1fr_minmax(420px,auto)] md:grid-rows-1 md:py-4 lg:grid-cols-[1fr_minmax(512px,auto)] xl:grid-cols-[1fr_minmax(640px,auto)]">
            <main className="flex w-full flex-col items-center justify-center rounded-b-3xl bg-white p-8 sm:p-12 md:order-2 md:rounded-tl-3xl md:rounded-br-none">
                <div className="bg-primary-600 flex size-12 shrink-0 items-center justify-center rounded-md p-2">
                    <img src={logo} alt="SmartPark logo" />
                </div>
                {children}
            </main>

            <aside className="relative flex flex-1 items-center justify-center py-8 md:p-8">
                <img className="absolute size-full object-cover opacity-50" src={landing} alt="asd"></img>
                <div className="from-primary-200/50 to-primary-800/50 flex-col rounded-2xl bg-linear-to-br p-4 backdrop-blur-xs">
                    <Carousel className="flex max-w-md flex-col items-center gap-4 lg:max-w-lg xl:max-w-xl 2xl:max-w-2xl">
                        <CarouselContent className="text-center text-white">
                            {LANDING_SLIDES.map((slide, index) => (
                                <CarouselItem key={`${slide.title.id}-${index}`}>
                                    <img src={slide.image} alt={formatMessage(slide.title)} />
                                    <CarouselItemTitle>
                                        <FormattedMessage {...slide.title} />
                                    </CarouselItemTitle>
                                    <CarouselItemSubtitle className="text-primary-100">
                                        <FormattedMessage {...slide.subtitle} />
                                    </CarouselItemSubtitle>
                                </CarouselItem>
                            ))}
                        </CarouselContent>
                        <div className="flex items-center justify-between gap-4">
                            <CarouselPrevious />
                            <div className="flex gap-4">
                                {LANDING_SLIDES.map((_, index) => (
                                    <CarouselDotButton key={index} index={index} />
                                ))}
                            </div>
                            <CarouselNext />
                        </div>
                    </Carousel>
                </div>
            </aside>
        </div>
    );
};

export { AuthLayout };
